'use strict'

import $ from 'jquery/dist/jquery';
import * as axios from 'axios'; // using axios instead of xhr/ajax

// datatable imports. 
import 'datatables.net/js/jquery.dataTables.min'; //main table file
import 'datatables.net-bs/js/dataTables.bootstrap.min'; //core bootstrap table theme
import 'datatables.net-bs/css/dataTables.bootstrap.min.css'; //core bs4 table theme
import 'datatables.net-buttons/js/dataTables.buttons'; // core button files
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min'; // bs4 buttons
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css'; // bs4 button styles
import 'datatables.net-fixedheader-bs4/css/fixedHeader.bootstrap4.min.css'; // fixed header 
import 'datatables.net-fixedheader-bs4/js/fixedHeader.bootstrap4.min'; // fixed header 
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.min';
import 'datatables.net-select/js/dataTables.select.min';
import 'datatables.net-select-bs4/js/select.bootstrap4.min';
import 'datatables.net-select-bs4/css/select.bootstrap4.min.css';



var mainTableData = [];
const LATEST_TRANSACTIONS_URL = 'https://api.mazzuma.com/something_something';
const SEARCH_TRANSACTIONS_URL = 'https://api.mazzuma.com/something_else';
const TEST_TRANSACTIONS_URL = 'https://jsonplaceholder.typicode.com/users';

var blockTable;
var transactionsTable;
let dataTemplate = {
    "chain": [{
            "index": 1,
            "previous_hash": "1",
            "proof": 100,
            "timestamp": 1542187544.6319885,
            "transactions": []
        },
        {
            "index": 2,
            "previous_hash": "45773d5ddd3ef0a7992f7c0f9e7bdd19e62fbd2bc138cb591120abde2c249aa7",
            "proof": 15417,
            "timestamp": 1542188325.261013,
            "transactions": [{
                    "amount": 31.15,
                    "id": "444UB332000568",
                    "recipient": "0203155814",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 12.41,
                    "id": "UL12348",
                    "recipient": "0272656871",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 1.53,
                    "id": "444WR412232",
                    "recipient": "0244568241",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 1,
                    "id": "444WR5231113",
                    "recipient": "2161030891590",
                    "sender": "Unitylink",
                    "status": "pending"
                },
                {
                    "amount": 76.28,
                    "id": "444UB15336133",
                    "recipient": "0160044418275401",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 63.24,
                    "id": "1811140585",
                    "recipient": "0160044418275401",
                    "sender": "Unitylink",
                    "status": "pending"
                }
            ]
        },
        {
            "index": 3,
            "previous_hash": "23324b6cb3b46af01fb25597e4361316e1acb956922a00fe29f968e77d805818",
            "proof": 155667,
            "timestamp": 1542188503.08259,
            "transactions": [{
                    "amount": 13.23,
                    "id": "444UL264233",
                    "recipient": "1544322642",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 16.23,
                    "id": "444UL26322",
                    "recipient": "623344322642",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 16.23,
                    "id": "444UB236344",
                    "recipient": "26664213452",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 1.25,
                    "id": "444UB2363133",
                    "recipient": "26664213452",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 21.54,
                    "id": "444UB236466223133",
                    "recipient": "26664213452",
                    "sender": "Unitylink",
                    "status": "success"
                }
            ]
        },
        {
            "index": 4,
            "previous_hash": "882dd367d97de87b25ab5aed700cef3a3d5e04e902b0e024f20d2f692d7e7256",
            "proof": 5175,
            "timestamp": 1542188666.2664182,
            "transactions": [{
                    "amount": 52.12,
                    "id": "444UB2364663434",
                    "recipient": "7431314433",
                    "sender": "Unitylink",
                    "status": "pending"
                },
                {
                    "amount": 1.12,
                    "id": "444UB23646632334",
                    "recipient": "7431314433",
                    "sender": "Unitylink",
                    "status": "pending"
                },
                {
                    "amount": 1.12,
                    "id": "444UB55646632334",
                    "recipient": "13743135113",
                    "sender": "Unitylink",
                    "status": "pending"
                },
                {
                    "amount": 7.14,
                    "id": "444UB55646632334",
                    "recipient": "13743135113",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 19.23,
                    "id": "444UB25133234",
                    "recipient": "5213743135113",
                    "sender": "Unitylink",
                    "status": "success"
                }
            ]
        },
        {
            "index": 5,
            "previous_hash": "c52bf553f2b3ef8ab4474b2d50ad5fee12e6e6110c65ddbf67c3f655e985b351",
            "proof": 30694,
            "timestamp": 1542188838.3576045,
            "transactions": [{
                    "amount": 53.14,
                    "id": "44425VA133234",
                    "recipient": "52311332533",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 12.32,
                    "id": "44425VA56233",
                    "recipient": "12636623312",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 12.32,
                    "id": "444VA7714423",
                    "recipient": "126724644424",
                    "sender": "Unitylink",
                    "status": "success"
                },
                {
                    "amount": 62.12,
                    "id": "444VA626443",
                    "recipient": "64421124424",
                    "sender": "Unitylink",
                    "status": "success"
                }
            ]
        }
    ],
    "length": 5
}

function initTables() {
    return new Promise((resolve, reject) => {
        //init tables without data. Add data in load functions
        $('#latest_blocks_table').append('<caption style="caption-side: top-right">Latest Blocks</caption>');
        blockTable = $('#latest_blocks_table').DataTable({
            responsive: true,
            fixedHeader: true,
            searching: true,
            processing: true,
            select: {
                style: 'single'
            },
            dom: 'Bfrtip',
            buttons: [{
                text: 'View Selected Block Transactions',
                action: function () {
                    let count = blockTable.row({
                        selected: true
                    }).data();

                    console.log(count);
                    if (count === 0) {
                        return;
                    }
                    // pass transactions list to transactions loader
                    loadTransactionsTable(count.transactions)
                }
            }],
            columns: [{
                    title: 'Index', // displayed column title
                    data: 'index' // data object key
                },
                {
                    title: 'Prev. Hash',
                    data: 'previous_hash'
                },
                {
                    title: 'Proof',
                    data: 'proof'
                },
                {
                    title: 'Time Stamp',
                    data: 'timestamp'
                }
            ]
        });


        $('#latest_transactions_table').append('<caption style="caption-side: top-right">Latest Transactions</caption>');
        transactionsTable = $('#latest_transactions_table').DataTable({
            responsive: true,
            fixedHeader: true,
            searching: true,
            processing: true,
            columns: [{
                    title: 'ID',
                    data: 'id'
                },
                {
                    title: 'Amount', // displayed column title
                    data: 'amount' // data object key
                },
                {
                    title: 'Recipient',
                    data: 'recipient'
                },
                {
                    title: 'Sender',
                    data: 'sender'
                },
                {
                    title: 'Status',
                    data: 'status'
                }
            ]
        });
        resolve();
    });

}

function loadBlockTable(tableData) {
    return new Promise((resolve, reject) => {
        console.log('Loading block table with', tableData);
        blockTable.rows().remove(); //clear old data from table
        blockTable.rows.add(tableData).draw();
        //resolve last block transaction array for use in transaction table 
        let lastBlock = tableData.slice(-1)[0];
        resolve(lastBlock);
    });

}

function loadTransactionsTable(tableData) {
    return new Promise((resolve, reject) => {
        console.log('Loading transactions table with, ', tableData);
        transactionsTable.rows().remove();
        transactionsTable.rows.add(tableData).draw();
        resolve();
    });

}

function getLatestBlocks() {
    return new Promise((resolve, reject) => {
        axios.get(TEST_TRANSACTIONS_URL)
            .then(res => {
                let latests = dataTemplate;
                //use data to fill table
                mainTableData = dataTemplate //mock data   
                //convert time stamps to readable formats    
                //console.log(mainTableData);  
                let tmp = dataTemplate;
                tmp.chain = dataTemplate.chain.map(e => {
                    e.timestamp = (new Date(e.timestamp * 1000)).toLocaleString();
                    return e;
                })
                resolve(tmp);
            })
            .catch(error => {
                console.log('Request Error: ', error)
                reject(error)
            })
    });

}

function initFooterDate() {
    return new Promise((resolve, reject) => {
        let date = document.getElementById('date');
        date.textContent = (new Date()).getFullYear();
        resolve();
    });

}

function init() {
    Promise.all([getLatestBlocks(), initTables(), initFooterDate()])
        .then(res => {
            // console.log(res);
            let blocks = res[0];
            //load block table with data 
            return loadBlockTable(blocks.chain);
        })
        .then(res => {
            //load transactions table with transactions from last block

            return loadTransactionsTable(res.transactions);
        })
        .catch(error => {
            console.log('Error in init promise chain ', error);
        });
}

function reloadBlockTable() {
    getLatestBlocks()
        .then(res => {
            let blocks = res;
            //load block table with data 
            return loadBlockTable(blocks.chain);
        })
}

function selectBlock(blockID) {


}




module.exports = {
    init,
    selectBlock
}
